import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';
import { SCVService } from 'src/app/service/scv.service';
import { noComponentFactoryError } from '@angular/core/src/linker/component_factory_resolver';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'scv-web';
  languages : any[];
 // selectedlanguage = new FormControl("fr");

  constructor(public translate:TranslateService,public scvService: SCVService){  
   // this.translate.setDefaultLang(this.selectedlanguage.value);
    translate.setDefaultLang('en');
  }

  ngOnInit(){
    //let language = this.scvService.getLanguage();
    //this.translate.setDefaultLang(language);
    this.populateDropDown();
  }
  handleEvent(e) {
     this.translate.setDefaultLang(e.value);
}
  

  /*(){
    console.log(this.selectedlanguage.value)
    this.translate.setDefaultLang(this.selectedlanguage.value);
  //  this.translate.use(this.selectedlanguage.value)
    this.populateDropDown();
  }*/
  populateDropDown() {
      this.languages = [
        {label: 'English', value: 'en'},
        {label: 'French', value:'fr'},
        {label: 'Lithuanian', value:'lt'},
        {label: 'Latvian', value:'lv'},
        {label: 'Czech', value:'cs'},
        {label: 'Danish', value:'da'},
        {label: 'German', value:'de'},
        {label: 'Greek', value:'el'},
        {label: 'Spanish', value:'es'},
        {label: 'Estonian', value:'et'},
        {label: 'Finnish', value:'fi'},
        {label: 'Hebrew', value:'he'},
        {label: 'Croatian', value:'hr'},
        {label: 'Hungarian', value:'hu'},
        {label: 'Italian', value:'it'},
        {label: 'Dutch', value:'nl'},
        {label: 'Norwegian', value:'no-no'},
        {label: 'Polish', value:'pl'},
        {label: 'Portuguese', value:'pt'},
        {label: 'Romanian', value:'ro'},
        {label: 'Russian', value:'ru'},
        {label: 'Slovak', value:'sk'},
        {label: 'Serbian', value:'srm'},
        {label: 'Swedish', value:'sv'},
        {label: 'Turkish', value:'tr'},
        {label: 'Bulgarian', value:'bg'},
        {label: 'Slovenian', value:'sl'}
      ];
    
  }
}
